import axios from "axios";
import { getAbstractService } from "./AbstractService";


export async function upload(id: string, file: File, onProgress?: (progress: number) => void) {
	const formData = new FormData();
	formData.append("file", file);
	//formData.append("filename", file.name);
	 // UTF-8 für textuelle Parts erzwingen
    formData.append(
        "filename",
        new Blob([file.name], { type: "text/plain; charset=utf-8" })
    );
	const res = await getAbstractService(
		{
			path: 'auftrag/'+id+'/upload',
			type: 'post',
			/*headers: {
				'Content-Type': 'multipart/form-data'
			},*/
			withCredentials: true,
			data: formData,
			onUploadProgress: onProgress ? (progressEvent) => {
				if (progressEvent.total) {
					const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
					onProgress(progress);
				}
			} : undefined,
			failCallback: (error: any) => {
				alert(error.message);
			}
		}
	);
	return res;
}


export async function downloadFile(uid: string) {
	
	const res = await axios({
		method: 'post',
		url: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + 'file/download/' + uid,
		responseType: 'arraybuffer',
		withCredentials: true,
	});
		
	return res;
}

export async function downloadDeckblatt	(uid: string) {
	
	const res = await axios({
		method: 'get',
		url: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + 'auftrag/deckblattPDF/' + uid,
		responseType: 'arraybuffer',
		withCredentials: true,
	});
		
	return res;
}

